import React, { useState } from "react";
import Autosuggest from "react-autosuggest";
import TextareaAutosize from "react-textarea-autosize";
import { useCaretPosition } from "react-use-caret-position";

// ... (previous imports and code)

function TriggerAutoCompleteTextarea({
	name,
	onHandleChange,
	currentValue,
	variables,
	maxLength,
	disabled = false,
	readOnly = false,
}) {
	const [value, setValue] = useState("");
	const [suggestions, setSuggestions] = useState([]);
	const [highlightedSuggestion, setHighlightedSuggestion] = useState(null);

	const getSuggestions = (value) => {
		const inputValue = value.trim().toLowerCase();
		const inputLength = inputValue.length;

		// Find the last occurrence of $
		const lastIndexOf$ = inputValue.lastIndexOf("$");

		// Always show suggestions when the input contains a $
		if (lastIndexOf$ !== -1) {
			return variables.filter((variable) =>
				variable.toLowerCase().startsWith(inputValue.slice(lastIndexOf$ + 1))
			);
		}

		return inputLength === 0
			? []
			: variables.filter(
					(variable) =>
						variable.toLowerCase().slice(0, inputLength) === inputValue
			  );
	};

	const getSuggestionValue = (suggestion) => suggestion;

	const renderSuggestion = (suggestion) => (
		<div
			className={`p-2 z-50 hover:bg-gray-200 ${
				highlightedSuggestion === suggestion ? "bg-gray-200" : ""
			}`}
		>
			{suggestion}
		</div>
	);

	const onChange = (event, { newValue, method }) => {
		setValue(newValue);
		onHandleChange(event);

		// Check if the change was triggered by a suggestion selection
		if (method === "click" || method === "enter") {
			// Find the last occurrence of $
			const lastIndexOf$ = newValue.lastIndexOf("$");
			// Append the highlighted suggestion to the current textarea value
			const updatedValue =
				highlightedSuggestion !== null
					? `${currentValue}${highlightedSuggestion} `
					: `${currentValue}${newValue.slice(lastIndexOf$ + 1)} `;
			// Update the parent component's state with the new value
			onHandleChange({
				target: { name, value: updatedValue.replaceAll("$$", "$") },
			});
			// Clear the input value and suggestions
			setValue("");
			setSuggestions([]);
			// Reset the highlighted suggestion
			setHighlightedSuggestion(null);
		}
	};

	const onSuggestionsFetchRequested = ({ value }) => {
		setSuggestions(getSuggestions(value));
	};

	const onSuggestionsClearRequested = () => {
		setSuggestions([]);
	};

	const onSuggestionHighlighted = ({ suggestion }) => {
		// Set the highlighted suggestion
		setHighlightedSuggestion(suggestion);
	};

	const onKeyDown = (event) => {
		// Handle arrow key navigation when the suggestions list is open
		if (suggestions.length > 0) {
			switch (event.key) {
				case "ArrowUp":
					event.preventDefault();
					setHighlightedSuggestion((prev) => {
						const index = suggestions.indexOf(prev);
						return index > 0
							? suggestions[index - 1]
							: suggestions[suggestions.length - 1];
					});
					break;
				case "ArrowDown":
					event.preventDefault();
					setHighlightedSuggestion((prev) => {
						const index = suggestions.indexOf(prev);
						return index < suggestions.length - 1
							? suggestions[index + 1]
							: suggestions[0];
					});
					break;
				default:
					break;
			}
		}

		// Handle the Enter key when the suggestions list is open
		if (event.key === "Enter" && suggestions.length > 0) {
			event.preventDefault(); // Prevent the default Enter behavior (e.g., form submission)
			// Simulate an "enter" change to handle the suggestion

			onChange(event, { newValue: value, method: "enter" });
		}
	};

	const renderInputComponent = (inputProps) => (
		<>
			<div>
				<TextareaAutosize
					disabled={disabled}
					cdkTextareaAutosize
					readOnly={readOnly}
					{...inputProps}
					onKeyDown={onKeyDown}
					// minRows={Math.ceil(10 / 1.2)}
					minRows={2}
					value={currentValue}
					// min-h-40 h-40
					className={`custom-height w-full border-2 focus:outline-yellow-400 rounded-md p-1 z-0 ${
						currentValue.length > maxLength
							? "border-red-500 focus:border-red-500"
							: " "
					}`}
					maxLength={maxLength}
				/>
			</div>
		</>
	);

	const inputProps = {
		placeholder: "Type a variable",
		value,
		name: name,
		onChange: onChange,
	};

	console.log({ currentLenght: currentValue.length });

	return (
		<div>
			<Autosuggest
				suggestions={suggestions}
				onSuggestionsFetchRequested={onSuggestionsFetchRequested}
				onSuggestionsClearRequested={onSuggestionsClearRequested}
				getSuggestionValue={getSuggestionValue}
				renderSuggestion={renderSuggestion}
				inputProps={inputProps}
				renderInputComponent={renderInputComponent}
				onSuggestionHighlighted={onSuggestionHighlighted}
				theme={{
					container: "relative ",
					suggestionsContainerOpen:
						"absolute mt-1 w-full bg-white border border-gray-300 rounded shadow-lg z-50 ",
					suggestionsList: "m-0 p-0 list-none",
					suggestion: "cursor-pointer",
					suggestionHighlighted: "bg-gray-200",
				}}
			/>

			<div className="grid grid-cols-2 items-center">
				<div className="col-span-1">
					{currentValue.length > maxLength && (
						<>
							<div className="text-red-500 text-xs">
								Error! Exceeding maximum length
							</div>
						</>
					)}
				</div>
				<div className="col-span-1 items-end justify-end grid">
					{currentValue.length}/{maxLength}
				</div>
			</div>
		</div>
	);
}

export default TriggerAutoCompleteTextarea;
